import { styled } from '@linaria/react';

export const ProcedureHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
`;

export const ProcedureSelectorWrapper = styled.div`
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const ProcedureSelect = styled.select`
    padding: 4px 8px;
    min-width: 250px;
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 350px;
`;
